var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleRightArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.113,
    height: 9,
    viewBox: "0 0 9.113 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "double-right-arrow-icon",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M4.956,14a.646.646,0,0,0,.456-.188L8.37,10.864a1.924,1.924,0,0,0,0-2.727L5.412,5.188A.644.644,0,1,0,4.5,6.1L7.46,9.046a.641.641,0,0,1,0,.909L4.5,12.9A.643.643,0,0,0,4.956,14Z",
    transform: "translate(0.176 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M11.13,14a.646.646,0,0,0,.456-.188l3.87-3.857a.641.641,0,0,0,0-.909l-3.87-3.857a.644.644,0,1,0-.912.909l3.412,3.4-3.414,3.4A.643.643,0,0,0,11.13,14Z",
    transform: "translate(-10.482 -5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRightArrowIcon);
export default __webpack_public_path__ + "static/media/double-right-arrow-icon.ec65c61c39a180648c951d0488868a6a.svg";
export { ForwardRef as ReactComponent };